import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@paypalcorp/pp-react';

export const feesCard = (feeCardContent = {}, handleClickFPTI) => {
  const featureItemKeys = Object.keys(feeCardContent);

  return (
    <div className="details-fees-total-card">
      {featureItemKeys.map(key => (
        <IncludedCardFee
          key={`details-fee-${key}`}
          componentContent={feeCardContent[key]}
          {...feeCardContent[key]}
          handleClickFPTI={handleClickFPTI}
        />
      ))}
    </div>
  );
};

export const feesSideSection = (feesSideContent = {}) => {
  const {
    feeSideTitle,
    feeSideSubtitle,
    feeSideLinkUrl,
    feeSideLinkText,
    feeSideFPTI,
    handleClickFPTI
  } = feesSideContent;

  return (
    <div className="details-fees-side">
      <h2>{feeSideTitle}</h2>
      <p className="font-size-p">{feeSideSubtitle}</p>
      <Link
        href={feeSideLinkUrl}
        onClick={() => (feeSideFPTI ? handleClickFPTI(feeSideFPTI) : {})}
      >
        {feeSideLinkText}
      </Link>
    </div>
  );
};

const IncludedCardFee = ({ componentContent = {}, handleClickFPTI }) => {
  const {
    cardTitle,
    fee,
    feeSubtext,
    cardFooterText,
    cardFooterLinkText,
    cardFooterLink,
    fptiLinkName
  } = componentContent;

  return (
    <div className="details-fees-card">
      <div className="details-fees-top-card">
        <h3>{cardTitle}</h3>
        <h4>{fee}</h4>
        <p
          className="font-size-p"
          dangerouslySetInnerHTML={{ __html: feeSubtext }}
        ></p>
      </div>
      {cardFooterText && (
        <div className="details-fees-bottom-card">
          <p
            className="pay-description font-size-p"
            dangerouslySetInnerHTML={{ __html: cardFooterText }}
          ></p>
          {cardFooterLink && (
            <a
              href={cardFooterLink}
              onClick={() => handleClickFPTI(fptiLinkName)}
            >
              {cardFooterLinkText}
            </a>
          )}
        </div>
      )}
    </div>
  );
};

feesCard.propTypes = {
  componentContent: PropTypes.object
};

IncludedCardFee.propTypes = {
  componentContent: PropTypes.object,
  cardTitle: PropTypes.string,
  fee: PropTypes.string,
  feeSubtext: PropTypes.string,
  cardFooterText: PropTypes.string,
  fptiLinkName: PropTypes.string,
  handleClickFPTI: PropTypes.func
};

feesSideSection.propTypes = {
  feeSideTitle: PropTypes.string,
  feeSideSubtitle: PropTypes.string,
  feeSideLinkUrl: PropTypes.string,
  feeSideLinkText: PropTypes.string
};

export default {
  feesCard,
  feesSideSection
};
